module.exports = __webpack_public_path__ + "static/media/instagramLogo_default.29211827.png";